
import { useRecoilValue } from "recoil";
import { IsLoginState, ProfileInfoState, useSetUserSession } from "../state/user-session";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "./header/header";
import { BackBtn } from "./header/btn/back-btn";
import GoogleLoginBtn from "./login-btn/google";
import KakaoLoginBtn from "./login-btn/kakao";
import NaverLoginBtn from "./login-btn/naver";
import Footer from "./footer";
import Swal from "sweetalert2";

const Sidebar = ({ isOpen, close }) => {
    const [, isLogin] = useRecoilValue(IsLoginState)
    const { profileName, profileLink } = useRecoilValue(ProfileInfoState)
    const [, logout] = useSetUserSession()
    const navigate = useNavigate()

    useEffect(() => {
        const sidebar = document.querySelector(".sidebar");

        if (sidebar == null) return

        const OPEN = "open";
        const CLOSE = "close";
        const CLOSING = "closing";

        if (isOpen) {
            sidebar.classList.remove(CLOSE)
            sidebar.classList.add(OPEN)
        } else {
            sidebar.classList.add(CLOSING);
            sidebar.addEventListener("animationend", () => {
                sidebar.classList.remove(OPEN)
                sidebar.classList.remove(CLOSING)
                sidebar.classList.add(CLOSE);
            }, { once: true })
        }

    }, [isOpen])

    const logoutAndRedirect = async () => {
        await logout()
        navigate("/login")
    }

    const notReadyPopup = () => {
        Swal.fire({
            title: '메뉴가 준비 중이에요!',
            text: '최대한 빨리 준비할게요!',
            customClass: 'swal-alert',
            allowOutsideClick: false,
            confirmButtonText: '확인',
            confirmButtonColor: '#2D2D2D'
        })
    }

    const toMyProfile = () => {
        //    TODO: 프로필 여러개 생각하기
        const profileUrl = `/profile/${profileLink}`
        navigate(profileUrl)
        navigate(0)
    }


    return (
        <div className="sidebar">
            <div className={`Layer sidebar-container`}>
                <Header >
                    <BackBtn onClick={close} />
                </Header>
                <div className="Layer-inner">
                    <div className="contents-container">
                        {!isLogin ?
                            <div className="title-container">
                                <div className="sidebar-first-desc">아래에서</div>
                                <div className="sidebar-second-desc">간편하게 로그인하세요</div>
                            </div> :
                            <div className="title-container">
                                <div className="sidebar-first-desc">{`${profileName}님,`}</div>
                                <div className="sidebar-second-desc">안녕하세요</div>
                            </div>
                        }
                    </div>
                    <div className="grid-wrapper">
                        <div className="grid-btn-container">
                            <button className={`${!isLogin ? "not-login" : ""}`} type="button"
                                onClick={notReadyPopup}>
                                계정 관리
                            </button>
                            <button className={`${!isLogin ? "not-login" : ""}`} type="button"
                                onClick={notReadyPopup}>
                                친구 목록
                            </button>
                            <button type="button" onClick={notReadyPopup}>
                                고객센터
                            </button>
                            <button type="button" className="img-contain-btn" onClick={notReadyPopup}>
                                <img src="/assets/img/logo.svg" className="small-logo" /> 구매
                            </button>
                        </div>
                    </div>
                    <>
                        {!isLogin ?
                            <div className="login-btn-container">
                                <p className="login-desc">다음 계정으로 로그인</p>
                                <div>
                                    <div className="login-btn-wrapper">
                                        <GoogleLoginBtn />
                                        <KakaoLoginBtn />
                                        <NaverLoginBtn />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="primary-btn-container">
                                <button className="btn primary" onClick={toMyProfile}>나의 Sign 페이지로 이동</button>
                                <button className="btn non" type="button" onClick={logoutAndRedirect}>로그아웃</button>
                            </div>

                        }
                    </>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Sidebar